import styled from 'styled-components';
import {
  companyColor,
  defaultColor,
  font,
  fluidFont,
  radius,
} from 'styles/theme';

export const Box = styled.div`
  margin-bottom: 1rem;
  margin-top: 1rem;
  height: 16rem;
`;

export const DepositCallout = styled.div`
  margin: 1rem 0;
  padding: 0.875rem 1rem;
  border-radius: ${radius('small')};
  background-color: ${defaultColor('backgroundLight')};
  border: 1px solid ${defaultColor('background')};
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const DepositRow = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 1rem;
`;

export const DepositLabel = styled.span`
  font-family: ${font('semibold')};
  ${fluidFont('13px', '15px')};
  color: ${companyColor('font')};
`;

export const DepositValue = styled.span`
  font-family: ${font('semibold')};
  ${fluidFont('13px', '15px')};
  color: ${companyColor('font')};
`;

export const DepositSubLabel = styled.span`
  ${fluidFont('11px', '13px')};
  color: ${defaultColor('gray')};
`;

export const DepositSubValue = styled.span`
  ${fluidFont('11px', '13px')};
  color: ${defaultColor('gray')};
`;

export const DepositNote = styled.div`
  ${fluidFont('11px', '13px')};
  color: ${defaultColor('gray')};
`;

export const CardSelect = styled.select`
  margin-top: 0.25rem;
  padding: 0.5rem 0.65rem;
  width: 100%;
  border-radius: ${radius('small')};
  border: 1px solid ${defaultColor('background')};
  ${fluidFont('13px', '14px')};
`;

export const CheckRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-top: 0.25rem;
`;

export const CheckLabel = styled.span`
  ${fluidFont('13px', '15px')};
  color: ${companyColor('font')};
  cursor: pointer;
`;
